import { createContext } from 'react';

const ToolbarContext = createContext();

export default ToolbarContext;